import { resourceExplorerViewsSelector } from "./resourceExplorerViewsSelector";
import { ResourceExplorer } from "../../../../services/cloudchipr.api";
import { RootState } from "../../../store";

export const resourceExplorerViewsDataSelector = (
  state: RootState,
): ResourceExplorer[] => {
  return resourceExplorerViewsSelector(state)?.data ?? [];
};
